<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>缺陷筛选</el-breadcrumb-item>
			<el-breadcrumb-item>工单列表</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="时间范围">
					<DateRange v-model="dateRange" />
				</el-form-item>
				<el-form-item label="机台">
					<el-select v-model="jt_id" placeholder="请选择机台" :clearable="true">
						<el-option-group v-for="group in jtData" :key="group.value" :label="group.label">
							<el-option v-for="item in group.jtList" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-option-group>
					</el-select>
				</el-form-item>
				<el-form-item label="批次">
					<el-input placeholder="请输入批次关键字" v-model="batchName" maxlength="150" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="标签">
					<el-input placeholder="请输入标签内容" v-model="label" maxlength="150" show-word-limit></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="info" @click="query">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div>
			<el-table border :data="tableData" row-key="id" v-loading="tableLoading" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
				<el-table-column width="30"></el-table-column>
				<el-table-column prop="index" width="60" label="序号"></el-table-column>
				<el-table-column prop="productName" label="产品名称"></el-table-column>
				<el-table-column prop="jtName" label="机台" width="120"></el-table-column>
				<el-table-column prop="workCode" label="工单号" width="120"></el-table-column>
				<el-table-column prop="batchCode" label="批次号" width="120"></el-table-column>
				<el-table-column prop="label" label="标签" width="180"></el-table-column>
				<el-table-column prop="batchStatus" label="批次状态" width="80"></el-table-column>
				<el-table-column prop="filterStatus" label="筛选状态" width="80"></el-table-column>
				<el-table-column prop="inspCount" label="检测张数" width="80"></el-table-column>
				<!-- <el-table-column prop="badCount" label="坏品张数" width="80"> </el-table-column> -->
				<el-table-column prop="totalLength" label="总长度" width="150" :formatter="formatter"></el-table-column>
				<el-table-column prop="totalDefCount" label="缺陷个数" width="120"></el-table-column>
				<el-table-column prop="totalBadCount" label="真实缺陷个数" width="120"></el-table-column>
				<el-table-column prop="beginTime" label="开始时间" width="170"></el-table-column>
				<el-table-column prop="endTime" label="结束时间" width="170"></el-table-column>
				<el-table-column prop="filter_time" label="筛选时间" width="170"></el-table-column>

				<el-table-column width="200" fixed="right">
					<template slot-scope="scope">
						<!-- <el-button type="text" icon="el-icon-s-data">工单报表</el-button> -->
						<el-button type="text" icon="el-icon-s-data" @click="handleViewTechInfo(scope.row)" v-if="scope.row.target == 'job_order'">工艺信息</el-button>
						<el-button type="text" icon="el-icon-s-data" @click="handleBrowser(scope.row)" v-if="scope.row.target == 'defect_statis'">缺陷浏览</el-button>
						<el-button type="text" icon="el-icon-s-data" @click="handleViewColorInfo(scope.row)" v-if="scope.row.target == 'job_order'">颜色信息</el-button>
						<!-- <el-button type="text" icon="el-icon-s-data" @click="handleViewReport(scope.row)" v-if="scope.row.target == 'defect_statis'">缺陷报表</el-button> -->
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!--分页-->
		<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	import dictionaryData from '@/service/dictionaryData'
	import jobOrderService from '@/service/jobOrderService'
	import { like, $in } from '@/network/util/QueryBuilder'
	export default {
		components: {
			DateRange,
		},
		data() {
			return {
				jt_id: '',
				jtData: [],
				dateRange: [],
				tableData: [],
				tableLoading: false,
				pageCount: 1,
				pageSize: 10,
				pageIndex: 1,
				batchName: '',
				label: '',
				batchFilterStatus: -1,
				filterStatus: [
					{
						value: 0,
						label: '未筛选',
					},
					{
						value: 1,
						label: '正在筛选',
					},
					{
						value: 2,
						label: '筛选完成',
					},
				],
			}
		},
		watch: {},
		methods: {
			formatter(row, column) {
				return typeof row.totalLength === 'number' && row.totalLength >= 0 ? (row.totalLength / 1000).toFixed(3) : ''
			},
			/**
			 * 搜索。
			 */
			query() {
				this.pageIndex = 1
				this.tableLoading = true

				let filter = {}
				if (this.dateRange && this.dateRange.length > 1) {
					filter.begin_time = {
						$gte: { $date: new Date(this.dateRange[0]).getTime() },
						$lte: { $date: new Date(this.dateRange[1]).getTime() },
					}
				}
				/**
				 * 批次名称
				 */

				if (this.batchName) {
					filter.roll_code = like(this.batchName)
				}
				/**
				 * 机台信息
				 */

				if (this.jt_id) {
					filter.jt_id = this.jt_id
				}
				/**
				 * 标签信息
				 */

				if (this.label) {
					filter.label = like(this.label)
				}

				// if (this.batchFilterStatus >= 0 && this.batchFilterStatus <= 2) {
				// 	filter.filter_status = this.batchFilterStatus

				this.loadData(filter)
			},
			/**
			 * 加载数据。
			 */
			loadData(filter) {
				jobOrderService.getJobOrderDefectStatisAsync(this.pageIndex, this.pageSize, filter).then(res => {
					this.tableData = res.data
					this.pageCount = res.totalPage
					this.tableLoading = false
					console.log('筛选数据内容', this.tableData)
				})
			},
			/**
			 * 切换页码。
			 */
			handleCurrentChange(page) {
				this.tableLoading = true
				console.log('tableLoading', this.tableLoading)
				this.pageIndex = page
				this.loadData()
			},
			/**
			 * 修改每页记录数量。
			 */
			handleSizeChange(size) {
				this.tableLoading = true
				this.pageIndex = 1
				this.pageSize = size
				this.loadData()
			},
			/**
			 * 缺陷浏览。
			 */
			handleBrowser(row) {
				const routeData = this.$router.resolve({ name: 'Browser', query: { batch_id: row.id } })
				window.open(routeData.href, '_blank')
			},
			/**
			 * 查看报表。
			 */
			handleViewReport(row) {
				this.$router.push({ name: 'DefectReport' })
			},
			handleViewTechInfo(row) {
				this.$router.push({ name: 'DefectFilterStat', query: { id: row.id } })
			},
			handleViewColorInfo(row) {
				console.log('查看缺陷统计', row)
				const routeData = this.$router.push({ name: 'ColorInforOrderStatisticalView', query: { id: row.id, type: row.target } })
				// window.open(routeData.href, '_blank')
			},
		},
		async created() {
			this.tableLoading = true
			this.jtData = await dictionaryData.getJTListGroupByWorkshop()
			this.query()
		},
	}
</script>

<style></style>
